import React, { useEffect } from 'react';
import PieChart, {
  Series,
  Label,
  Connector,
  Export,
  Tooltip,
  Legend,
} from 'devextreme-react/pie-chart';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function EventChart(props) {
  const { t } = useTranslation();

  const customizePoint = (pointInfo) => {
    return { color: pointInfo.data.color };
  };

  const customizeText = (text) => {
    if (text.point.data.minuteamount !== undefined) {
      return text.point.data.minuteamount;
    } else {
      return text.originalValue;

    }
    // return   {color: pointInfo.data.color};
  };

  const customizeTooltip = (pointinfo) => {
    let detailName = pointinfo.argument;
    let htmlText = '';
    htmlText += '<b style="text-style: underline">' + detailName + '</b><br/>'
    // if(seriesName === 'Total'){
    if (pointinfo.point.data !== null) {
      htmlText += '<div>' + getPercentage(pointinfo.percent) + ' - ' + ((pointinfo.point.data.type === 2 || (pointinfo.point.data.type === 7 && pointinfo.point.data.externalApiTypeId === 2)) ? pointinfo.point.data.minuteamount : pointinfo.value + ' ' + t('eventChart.events')) + '</div>';
      // resourceName
      // Embed MapPin icon as an SVG inside the tooltip
      htmlText += `<div style="margin-top: 12px; display: flex; align-items: center;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0 1 18 0Z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span style="margin-left: 5px;">${pointinfo.point.data.resourceName}</span>
                  </div>`;
    }
    return {
      html: htmlText,
    };
  }
  const onLegendClick = ({ points }) => {
    points[0].isVisible() ? points[0].hide() : points[0].show();

  }

  // Turn a decimal into a percentage - 0.234 -> 23.40%
  const getPercentage = (decimalPercentage) => {
    let percentage = (decimalPercentage * 100).toFixed(2);
    return percentage + "%";
  }

  return (
    <PieChart id="pie" dataSource={props.data} palette="Bright" title={props.title} customizePoint={customizePoint} onLegendClick={onLegendClick}>
      <Tooltip enabled={true} customizeTooltip={customizeTooltip}></Tooltip>
      <Legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top" ></Legend>
      <Series argumentField="detailDescription" valueField="amount"      >
        <Label visible={true} customizeText={customizeText}>
          <Connector visible={true} width={1} />
        </Label>
      </Series>
      <Export enabled={true} />
    </PieChart>

  );
}
